export const footToMeter = (value) => {
    return value / 3.28084;
};
export const footToFlightLevel = (value) => {
    return Math.floor(value / 100);
};
export const feetToKilometerConverter = (value) => {
    return meterToKilometer(footToMeter(value));
};
export const meterToFoot = (value) => {
    return value * 3.2808;
};
export const meterToKilometer = (value) => {
    return value / 1000;
};
export const meterToMile = (value) => {
    return value / 1609.344;
};
export const meterToNauticalMile = (value) => {
    return value / 1852;
};
export const metersPerSecondToKnot = (value) => {
    return value * 1.94384;
};
export const metersPerSecondToFeetPerMinute = (value) => {
    return value * 196.85;
};
export const metersPerSecondToKilometersPerHour = (value) => {
    return value * 3.6;
};
export const metersPerSecondToMilesPerHour = (value) => {
    return value * 2.23694;
};
export const celciusToFahreinheit = (value) => {
    return value * 1.8 + 32;
};
export const celciusToKelvin = (value) => {
    return value + 273.15;
};
export const hectopascalToInchesOfMercury = (value) => {
    return value / 33.86388;
};
export const millimeterToCentimeter = (value) => {
    return value / 10;
};
export const millimeterToMeter = (value) => {
    return value / 1000;
};
export const millimeterToInch = (value) => {
    return value / 25.4;
};
export const degreeToDms = (value) => {
    const degrees = value < 0 ? Math.ceil(value) : Math.floor(value);
    const minutes = Math.floor((Math.abs(value) - Math.abs(degrees)) * 60);
    const seconds = (Math.abs(value) - Math.abs(degrees) - minutes / 60) * 3600;
    return [degrees, minutes, seconds];
};
export const kilogramToPound = (value) => {
    return value * 2.20462;
};
export const kilogramToTonne = (value) => {
    return value / 1000;
};
export const poundToUSTon = (value) => {
    return value / 2000;
};
//# sourceMappingURL=converter.js.map